import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { mapProps } from 'recompose';
import { withRouter } from 'react-router-dom';

import getSimplifiedAlbumMembershipGroup from '../../graphql/queries/getSimplifiedAlbumMembershipGroup';
import { ALBUM_FOLDER_TAG_TYPE } from '../../../../../../../constants/album-folder-tags';
import { CURRENCY } from '../../../../../../../constants/currency';
import { toggleAlbumMembershipGroupFilter as toggleAlbumMembershipGroupFilterAction } from '../../../../../redux/memberships/membershipsActions';
import Button from '../../../../../../../components/global/Button';
import CustomControl from '../../../../../../../components/global/CustomControl';
import DropdownMenu from '../../../../../../../components/global/DropdownMenu';
import FilterIcon from '../../../../../../../components/icons/FilterIcon';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
    is_album: PropTypes.bool,
    album: PropTypes.shape({
      id: PropTypes.string,
      root_album_folder: PropTypes.shape({
        id: PropTypes.string,
        tags: PropTypes.shape({
          total: PropTypes.number,
          records: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string,
              name: PropTypes.string,
              type: PropTypes.oneOf(Object.values(ALBUM_FOLDER_TAG_TYPE)),
              digital_downloads_price: PropTypes.shape({
                value: PropTypes.number,
                currency: PropTypes.oneOf(Object.values(CURRENCY)),
              }),
            }),
          ),
        }),
      }),
    }),
    album_folder: PropTypes.shape({
      id: PropTypes.string,
      tags: PropTypes.shape({
        total: PropTypes.number,
        records: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            type: PropTypes.oneOf(Object.values(ALBUM_FOLDER_TAG_TYPE)),
            digital_downloads_price: PropTypes.shape({
              value: PropTypes.number,
              currency: PropTypes.oneOf(Object.values(CURRENCY)),
            }),
          }),
        ),
      }),
    }),
    album_memberships_has_all_photos_access: PropTypes.bool,
  }),
  albumMembershipGroupFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggleAlbumMembershipGroupFilter: PropTypes.func.isRequired,
};

const PhotoFilterDropdown = ({
  location,
  albumMembershipGroup,
  albumMembershipGroupFilters,
  toggleAlbumMembershipGroupFilter,
}) => {
  const albumFolder = albumMembershipGroup?.is_album
    ? albumMembershipGroup?.album?.root_album_folder
    : albumMembershipGroup?.album_folder;

  const tagsWithPricing = (albumFolder?.tags?.records ?? []).filter(
    tag => (tag?.digital_downloads_price?.value ?? 0) > 0,
  );

  if (
    tagsWithPricing.length === 0 ||
    location?.pathname === `/consumer/matches/${albumMembershipGroup?.id}/all`
  ) {
    return null;
  }

  return (
    <div className="dropdown-menu-dark">
      <DropdownMenu
        toggle={
          <Fragment>
            <FilterIcon color="#0d84fe" size={20} className="mb-1" />
            <p>Filters</p>
          </Fragment>
        }
        placement="bottom-end"
        closeOnClickWithin
        dropdownClassName="photo-filter-dropdown"
        toggleClassName="photo-filter-dropdown-toggle"
      >
        <div className="d-flex mb-1 text-extra-bold">Filter:</div>
        {tagsWithPricing.map(tag => (
          <Button
            btnStyle="link"
            btnSize="sm"
            className="d-flex align-items-center mb-1"
            key={tag.id}
            onClick={() => {
              toggleAlbumMembershipGroupFilter(tag.id);
            }}
          >
            <CustomControl
              id="-cb"
              type="checkbox"
              labelSrOnly
              checked={albumMembershipGroupFilters.includes(tag.id)}
              readOnly
            />
            <span className="text-white">{tag.name} Photos</span>
          </Button>
        ))}
      </DropdownMenu>
    </div>
  );
};

PhotoFilterDropdown.propTypes = propTypes;

const mapStateToProps = ({ consumer: { memberships } }) => ({
  albumMembershipGroupFilters: memberships.albumMembershipGroupFilters,
});

const mapDispatchToProps = {
  toggleAlbumMembershipGroupFilter: toggleAlbumMembershipGroupFilterAction,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  mapProps(props => ({
    ...props,
    albumMembershipGroupId: props.match.params.albumMembershipGroupId,
  })),
  getSimplifiedAlbumMembershipGroup,
  mapProps(({ data, ...props }) => ({
    ...props,
    albumMembershipGroup: data?.albumMembershipGroup,
  })),
)(PhotoFilterDropdown);
